import Page from '..';
import Form from '../../Form';

export default function PageRecover() {
  return (
    <Page className="page-recover">
      <div
        style={{
          position: 'fixed',
          top: '15%',
          left: '50%',
          background: '#ececec',
          width: '30vw',
          borderRadius: '10px',
          transform: 'translateX(-50%)',
          padding: '2rem 2rem 2rem 2rem',
        }}
      >
        <h1
          style={{
            marginBlockStart: '0',
            marginBlockEnd: '2.5rem',
          }}
        >
          Recuperar Senha
        </h1>
        <Form.RecoverPassword />
      </div>
    </Page>
  );
}
